import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectGatewaysListItems } from "../../../../../redux/gateways/selector";
import { gateways } from "../../../../../redux/gateways/action";

const Gateways = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const gatewayItems = useSelector(selectGatewaysListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
     
          { field: 'Name', headerName: 'Gateway Name', searchField: 'Name', filter: true,
            filterType: 'text' },
            { field: 'Types', headerName: 'Type',  valueFormatter: getTypeName ,filterType: 'text' },
            { field: 'PlatformDBAName', headerName: 'DBA Name',  filterType: 'text' },
          { field: 'Description', headerName: 'Description',  filterType: 'text' },
        ]);
      }
      const getTypeName = (data: any) => {
        if (Array.isArray(data)) {
            return data.join('\n'); 
        }
        return data;
    };
      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(gateways.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways/list`,entity:'domains',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
      const handleReloadData = () => {
        dispatch(gateways.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways/list`,entity:'domains',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
     
      const fetchGateways=()=>{
        dispatch(gateways.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways/list`,entity:'domains',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
       navigate(`${data.Id}`)
      }
	useEffect(() => {
        createColumnDefs()
        fetchGateways()
	}, [pageData,pageSize])
    const additionButtons: any = [
        {
          svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Domain</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];

      const handleDelete=(data: any)=>{
        dispatch(gateways.delete({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways/delete`,entity:'domains',jsonData:{
            Records: [
              {
             
                    Id: data?.Id
                }
              
            ]
          }
      })).then(() => {
        dispatch(gateways.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways/list`,entity:'domains',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      });
      }
	return (
    <>
    {gatewayItems?.isLoading ?  <PageLoader />: 
		<Table  enableFilter={true}
    filterTypeLists={filterTypes}  setPageSize={setPageSize}
    onSearch={handleSearch} columnData={columnDefs} rowData={gatewayItems?.result?.items} setPageData={setPageData}
    paginationData={gatewayItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Gateways"/>
     
  }
  </> 
	);
};

export default Gateways;


